<div class="cppOrderSummary">
  <div class="row">
    <div class="prepayContractOuter print-area" id="print-section">
      <div class="prepayContractTop">
        <div class="prepayContract">
          <div class="order-view-sec breadcrumbOuter padding-0 col-md-12">
          </div>
          <div class="row statusNotice" *ngIf="!showErrorItems">
            <div class="col-md-12">
              <span class="fontCondBold margin-r20">
                Status Notice:
              </span>
              {{statusNotice}}
            </div>
          </div>
          <div class="row errorSummary" *ngIf="showErrorItems">
            <div class="col-md-2 fontCondBold">
              Status Notice:
            </div>
            <div class="col-md-10">
              {{statusNotice}}
            </div>
          </div>
          <div class="row contract-info topMargin mx-auto">
            <div class="col-md xs-mb-15 md-mb-0 font11">
              <p><span class="w-95 font11">COI Request #: </span><strong><span>{{webOrderNumber}}</span></strong></p>
              <p>
                <span class="w-95 font11">CREATED:</span><strong><span>{{shipToAccountdetails.CreatedOn | date:'MM/dd/yyyy'}}</span></strong>
              </p>
              <p>
                <span class="w-95 font11">PLACED BY:</span><strong><span>{{shipToAccountdetails.PlacedByName}}</span></strong>
              </p>
              <p>
                <span class="w-95 font11">
                  CUSTOMER
                  PO#:
                </span><strong><span>{{shipToAccountdetails.CustomerPONumber}}</span></strong>
              </p>
              <p *ngIf="isBulkItemAvailable">
                <span class="w-95">
                  BULK CONTACT NAME:
                </span><strong><span>{{bulkContactName}}</span></strong>
              </p>
              <p *ngIf="isBulkItemAvailable">
                <span class="w-95">
                  BULK CONTACT PHONE NUMBER:
                </span><strong><span>{{bulkContactNumber}}</span></strong>
              </p>
              <p *ngIf="packagedContactName"><span class="w-95">CONTACT NAME: </span><strong><span data-testid="lbl-ordernumb">{{packagedContactName}}</span></strong></p>
              <p *ngIf="packagedContactNumber"><span class="w-95">CONTACT PHONE NUMBER: </span><strong><span data-testid="lbl-ordernumb">{{packagedContactNumber}}</span></strong></p>
              <p *ngIf="packagedDeliveryInst"><span class="w-95">DELIVERY INSTRUCTIONS: </span><strong><span data-testid="lbl-ordernumb">{{packagedDeliveryInst}}</span></strong></p>
            </div>

            <div class="col-md xs-mb-15 md-mb-0 font11" *ngIf="soldToAccountdetails.AccountName">
              <p>
                <span class="xs-w-95 font11">SOLD TO:</span> <strong>
                  <span class="d-flex" *ngIf="soldToAccountdetails.AccountNumber"><span class="font11">{{soldToAccountdetails.AccountNumber}}</span> </span>
                  <span *ngIf="soldToAccountdetails.AccountName">{{soldToAccountdetails.AccountName}}</span>
                  <span *ngIf="soldToAccountdetails.Address1">{{soldToAccountdetails.Address1}}</span>
                  <span *ngIf="soldToAccountdetails.Address1">{{soldToAccountdetails.Address2}}</span>
                  <span *ngIf="soldToAccountdetails.AccountCity">
                    {{soldToAccountdetails.AccountCity}} , {{soldToAccountdetails.AccountState}}
                    <span *ngIf="soldToAccountdetails.AccountZipCode"
                          class="margin-l5 display-ib">{{soldToAccountdetails.AccountZipCode}}</span>
                  </span>
                </strong>
              </p>
            </div>

            <div class="col-md xs-mb-15 md-mb-0 font11">
              <p>
                <span class="xs-w-95">SHIP TO:</span> <strong>
                  <span class="d-flex"><span class="font11">{{shipToAccountdetails.AccountNumber}}</span></span>
                  <span>{{shipToAccountdetails.AccountName}}</span>
                  <span>{{shipToAccountdetails.Address1}}</span>
                  <span class="padding-r5">
                    {{shipToAccountdetails.AccountCity}} , {{shipToAccountdetails.AccountState}}
                    <span class="display-ib">{{shipToAccountdetails.AccountZipCode}}</span>
                  </span>
                </strong>
              </p>
            </div>

            <div class="col-md xs-mb-15 md-mb-0 font11" *ngIf="deliverToAccountdetails.AccountName">
              <p>
                <span class="xs-w-95">DELIVER TO:</span> <strong>
                  <span class="d-flex"><span class="font11">{{deliverToAccountdetails.AccountNumber}}</span> </span>
                  <span *ngIf="deliverToAccountdetails.AccountName">{{deliverToAccountdetails.AccountName}}</span>
                  <span *ngIf="deliverToAccountdetails.Address1">{{deliverToAccountdetails.Address1}}</span>
                  <span *ngIf="deliverToAccountdetails.AccountCity">
                    {{deliverToAccountdetails.AccountCity}} , {{deliverToAccountdetails.AccountState}}
                    <span *ngIf="deliverToAccountdetails.AccountZipCode"
                          class="margin-l5 display-ib">{{deliverToAccountdetails.AccountZipCode}}</span>
                  </span>
                </strong>
              </p>
            </div>

            <div class="col-md xs-mb-15 md-mb-0" *ngIf="dsmAccountDetails.AccountName">
              <p>
                <span class="xs-w-95">DSM:</span>
                <strong>
                  <span class="font11">{{dsmAccountDetails.AccountName}}</span>
                  <div class="margin-t10 font11">
                    <span *ngIf="dsmAccountDetails.Email">{{dsmAccountDetails.Email}}</span>
                  </div>
                </strong>
              </p>
            </div>
          </div>

          <div class="row margin-t10 no-gutters contract-info">
            <div class="text-center text-md-left xs-mb-20 md-mb-0 col-md-7 padding-l0 pdfText">
              <span class="md-ml-15 round-icon xs-mr-35 md-mr-15 mobile-round" (click)="generatedPdf(webOrderNumber)">
                <i class="far fa-file-pdf"></i>
              </span>
              View PDF to Print
            </div>
            <div class="d-none d-sm-none d-md-block col-md-5 text-right">
              <!--<button mat-raised-button class="btns largeBtn" *ngIf="(showBackToCppLanding && !readOnlyAccess)" (click)="createNewOrder()">New COI Request</button>-->
              <button mat-raised-button class="btns largeBtn" *ngIf="!readOnlyAccess" (click)="createNewOrder()">New COI Request</button>
            </div>
          </div>

          <!--<div class="row contract-info topMargin" *ngIf="isInstructionType">-->
          <div class="row contract-info topMargin">
            <div class="col-md-4" *ngIf="shipToAccountdetails.InstructionType">
              <div class="row">
                <div class="col-md-12">INSTRUCTION TYPE</div>
              </div>
              <div class="row">
                <div class="col-md-12"><span>{{shipToAccountdetails.InstructionType}}</span></div>
              </div>
            </div>
            <!--<div class="col-md-4" *ngIf="shipToAccountdetails.HeaderText">
              <div class="row">
                <div class="col-md-12">SPECIAL INSTRUCTION DETAIL</div>
              </div>
              <div class="row">
                <div class="col-md-12"><span>{{shipToAccountdetails.HeaderText}}</span></div>
              </div>
            </div>-->
            <!--<div class="col-md-4" *ngIf="shipToAccountdetails.CustomerPickUp">
              <div class="row">
                <div class="col-md-12">CUSTOMER PICK UP</div>
              </div>
              <div class="row">
                <div class="col-md-12"><span>{{shipToAccountdetails.CustomerPickUp}}</span></div>
              </div>
            </div>-->
          </div>
        </div>
      </div>

      <div class="prepayContBottom">
        <div class="prepayContract topMargin">
          <div>
            <button mat-raised-button class="btns largeBtn d-block d-sm-block d-md-none xs-full-width xs-button" *ngIf="(showBackToCppLanding && !readOnlyAccess)" (click)="createNewOrder()">New COI Request</button>
            <div class="OrderReleaseDetail">
              <div class="row">
                <div class="col-md-12 productTableOuter productMargin padding-0" *ngIf="cppProductItemsDataSource && cppProductItemsDataSource.length">
                  <div *ngFor="let item of cppProductItemsDataSource">
                    <div>
                      <div class="row" *ngIf="item.hasError">
                        <div class="col-md-12">
                          <button class=" textAlignment errorSummary">{{getErrorMessagesForProduct()}}</button>
                        </div>
                      </div>
                      <div class="row  margin-t20 margin-b10 xs-status-row">
                        <div class="col-md-3">
                          <span [attr.data-testid]="lblShippingInstruction"><b>Shipping Instructions: {{specialInstructionText}}</b></span>
                        </div>
                      </div>
                      <div class="row  margin-t20 margin-b10 xs-status-row">
                        <div class="col-md-6">
                          <span><b>COI Request ID: {{webOrderNumber}}-{{item.splitId}}</b></span>
                        </div>
                        <!--<div class="col-md-3">
                          <span *ngIf="!isRedirectedFromPlacedOrder && item.jdeorderNumber" (click)="NavigateToOTISummaryPage(item.jdeorderNumber)"><b>Sales Order Number: {{item.jdeorderNumber}}</b></span>
                          <span *ngIf="!isRedirectedFromPlacedOrder && item.jdeorderNumber && item.isAvailableInOTIHeader">
                            <b>
                              Sales Order Number:
                              <a style="text-decoration:underline" [routerLink]="" (click)="NavigateToOTISummaryPage(item.jdeorderNumber)">
                                {{item.jdeorderNumber}}
                              </a>
                            </b>
                          </span>
                        </div>-->
                        <!--<div class="col-md-4">
                          <span *ngIf="!isRedirectedFromPlacedOrder"><b>Status: <button [ngClass]="item.orderStatus =='ERROR' ? 'redstatusBtn' : 'statusBtn'">{{item.orderStatus}}</button></b></span>
                        </div>-->
                        <div class="col-md-6">
                          <span class="float-md-right" *ngIf="getDeliveryDate(item) && getDeliveryDateReason(item)"><b>Requested Arrival Date: <u matTooltip="{{getTooltipText(item)}}" matTooltipClass="dateTooltip" [matTooltipPosition]="'above'">{{getDeliveryDate(item) | date:'MM/dd/yyyy'}}</u></b></span>
                          <span class="float-md-right" *ngIf="getDeliveryDate(item) && !getDeliveryDateReason(item)"><b>Requested Arrival Date: {{getDeliveryDate(item) | date:'MM/dd/yyyy'}} </b></span>
                        </div>
                      </div>
                    </div>
                    <div class="tableContainer cppsummaryTable botMargin table-mobile">
                      <app-cpp-coi-grid-view [gridData]="item"></app-cpp-coi-grid-view>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="prepayBtnSec footer-action-button">
        <div class="row">
          <div class="col-md-12">
            <button mat-raised-button class="btns xs-button xs-full-width" (click)="backToLandingPage()">Back To Order List</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
